import { logger } from '@/utils/logger';

import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useTwoFactorAuth = () => {
  const [twoFactorCode, setTwoFactorCode] = useState('');

  const verify2FA = async (code: string, profile: any) => {
    const { data, error } = await supabase.functions.invoke('verify-2fa', {
      body: { code }
    });

    if (error || data?.error || !data?.verified) {
      throw new Error('Invalid 2FA code');
    }

    return true;
  };

  const handle2FAVerification = async (
    userProfile: any,
    currentOrganization: any,
    setTwoFactorVerified: (verified: boolean) => void,
    toast: any
  ) => {
    logger.debug('Starting 2FA verification...');

    const isValid = await verify2FA(twoFactorCode, userProfile);
    if (!isValid) {
      throw new Error('Invalid 2FA code. Please try again.');
    }

    logger.debug('2FA verification successful');
    setTwoFactorVerified(true);
    
    toast({
      title: "Welcome back!",
      description: `Signed in successfully to ${currentOrganization?.name || 'your organization'}`
    });
  };

  return {
    twoFactorCode,
    setTwoFactorCode,
    verify2FA,
    handle2FAVerification
  };
};
